import React, { useEffect, useRef, useState } from 'react'
import classes from "./style.module.scss";

const ModalDropdown = (props) => {
    const { isOpen, closePopUp, notifymodal = false, timeOutModal = false, boxAlign } = props
    const [isExiting, setIsExiting] = useState(false);
    const modalRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (props.selectBoxRef) {
                const targetElement = event?.target?.className;
                const modalClass = targetElement ? targetElement?.toString().split(' ')?.at(0) : null
                if (modalClass === 'modal-overlay') {
                    closeModal();
                }
            } else if (modalRef.current && !modalRef.current.contains(event.target) ) {
                const targetElement = event?.target?.className;
                if (targetElement?.toString().split(' ')?.at(0) === 'MuiButtonBase-root') {
                    return
                }
                closeModal();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, closePopUp]);

    useEffect(() => {
        if (timeOutModal && isOpen) {
            setTimeout(() => {
                closeModal()
            }, 3500)
        }
    }, [timeOutModal])

    const closeModal = () => {
        if (isOpen) {
            setIsExiting(true);
            setTimeout(() => {
                setIsExiting(false);
                closePopUp();
            }, 300);
        }
    };

    return (
        <div className={`modal-overlay ${classes.modalOverlay} ${(isOpen || isExiting) ? isExiting ? `${classes.isExiting}` : `${classes.isOpen}` : ''}`}>
            <div className={`${classes.modalDropdownWrapper} ${notifymodal ? classes.notifymodal : ''} ${boxAlign === 'center' ? classes.boxCenterAlign : ''}`} ref={modalRef}>
                {props.children}
            </div>
        </div>
    );
}

export default ModalDropdown